import {createStore} from '@ngneat/elf';
import {AksjeeierbokId, AksjeklasseModell} from "../ressurser/generertNg2HttpKlient";
import {selectManyByPredicate, withEntities} from "@ngneat/elf-entities";
import {Observable} from "rxjs";
import {Injectable} from "@angular/core";

import {forelderIdPredikat, registrerEntiteterMedForelder} from "./datatjeneste";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";

const debug = initDebugger('AksjeklasseDatatjeneste');

/**
 * Datalager for {@link AksjeklasseModell}.
 */
@Injectable() //tilgjengeliggjøres via DatalagerModul
export class AksjeklasseDatatjeneste {

    /** Lager for {@link AksjeklasseModell}. Bruker {@link AksjeeierbokId} som forelder */
    private aksjeklasseLager = createStore(
      {name: 'aksjeklasse'},
      withEntities<AksjeklasseModell>());

    constructor() {
    }

    finnAksjeklasserTilknyttet(aksjeeierbokId: AksjeeierbokId): Observable<AksjeklasseModell[]> {
        return this.aksjeklasseLager.pipe(selectManyByPredicate(forelderIdPredikat(aksjeeierbokId)));
    }

    // hjelpemetoder

    //for intern bruk
    registrerILager(aksjeklasser: AksjeklasseModell[], aksjeeierbokId: AksjeeierbokId) {
        registrerEntiteterMedForelder(this.aksjeklasseLager, aksjeklasser, aksjeeierbokId);
    }
}
